const { filter } = require('lodash');

class DynamicContentRestrictedProductGroupNavigationController {
    constructor($scope, $state, $location, breakpointsService, productGroupService) {
        this.$scope = $scope;
        this.$state = $state;
        this.$location = $location;

        this.breakpointsService = breakpointsService;
        this.productGroupService = productGroupService;
        this.categoryFilterName = productGroupService.getCategoryFilterName();
    }

    $onInit() {
        this.isSelectAll = this.filter === undefined;
        this.isCategoriesExpanded = true;
    }

    categoryClick(categoryId) {
        this.isSelectAll = categoryId === undefined;

        const path = this.$location.path();
        const parent = path.substring(path.lastIndexOf('/') + 1);
        const filters = categoryId !== undefined ? this.formFilters(categoryId) : undefined;
        this.$state.go('.', { filter: filters, parent }, { inherit: false });
    }

    formFilters(categoryId) {
        const applied = this.filter
            ? { filters: filter(this.filter.filters, f => f.Key !== this.categoryFilterName) }
            : { filters: [] };

        applied.filters.push({ Key: this.categoryFilterName, Items: [{ Term: categoryId }] });
        return applied;
    }

    isActiveCategory(category) {
        if (this.isSelectAll) {
            return false;
        }

        const categoryFilter = this.filter ? this.filter.filters.find(f => f.Key === this.categoryFilterName) : {};
        return category.NodeId === (categoryFilter && categoryFilter.Items ? categoryFilter.Items[0].Term : null);
    }

    toggleCategories() {
        this.isCategoriesExpanded = !this.isCategoriesExpanded;
    }
}

DynamicContentRestrictedProductGroupNavigationController.$inject = ['$scope', '$state', '$location', 'BreakpointsService', 'ProductGroupService'];

const dynamicContentRestrictedProductGroupNavigationComponentDefinition = {
    bindings: {
        filter: '<',
    },
    controller: DynamicContentRestrictedProductGroupNavigationController,
    template: require('./dynamic-content-restricted-product-group-navigation.component.html').trim(),
};

module.exports = {
    DynamicContentRestrictedProductGroupNavigationController,
    dynamicContentRestrictedProductGroupNavigationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/restrictedproductgroup/dynamic-content-restricted-product-group-navigation.component.js